// Feature flags — flip to true to reactivate
export const MOMENTUM_ACTIVO = false;

// Central Stripe configuration — single source of truth for all Price IDs
export const STRIPE_PRODUCTS = {
  // Primary plan — "Doer" ($139 MXN/mes)
  doer: {
    priceId: 'price_1TvSDIQ4fq45GDKS9omWHdvd',
    mode: 'subscription',
    name: 'Doer',
    price: 139,
    interval: 'month',
  },
  // Backward compat alias — existing subscribers still have spark_seeker in DB
  spark_seeker: {
    priceId: 'price_1TvSDIQ4fq45GDKS9omWHdvd',
    mode: 'subscription',
    name: 'Doer',
    price: 139,
    interval: 'month',
  },
  /* Legacy plans — kept for existing subscribers, hidden from UI */
  momentum_builder: {
    priceId: 'price_1TL2gtQ4fq45GDKSHXep3RRJ',
    mode: 'subscription',
    name: 'Momentum Builder',
    price: 27,
    interval: 'month',
  },
  growth_mastermind: {
    priceId: 'price_1TL2gtQ4fq45GDKSApHdZRfs',
    mode: 'subscription',
    name: 'Growth Mastermind',
    price: 44,
    interval: 'month',
  },
  clarity_mentor: {
    priceId: 'price_1TL2gpQ4fq45GDKSQ3l0ydlM',
    mode: 'payment',
    name: 'Clarity Mentor',
    price: 66,
    interval: 'one_time',
  },
  /* brujula_digital archived — replaced by tu_radar */
  tu_radar: {
    priceId: 'price_1TvS8mQ4fq45GDKSzHLVjWrj',
    mode: 'payment',
    name: 'Tu Radar',
    price: 599,
    interval: 'one_time',
  },
};

// Helper: get escritorio path by membership
export const ESCRITORIO_PATHS = {
  doer: '/arbol',
  spark_seeker: '/arbol',
  momentum_builder: '/escritorio/momentum',
  growth_mastermind: '/escritorio/growth',
  clarity_mentor: '/escritorio/clarity',
  tu_radar: '/escritorio/tu-radar',
};
